
import { defineComponent, reactive, onBeforeMount, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import FtlOrderState from '@/modules/FTLModule/components/FtlOrderState/index.vue'
import FtlOrderHeader from '@/modules/FTLModule/components/FtlOrderHeader/index.vue'
import FtlOrderTabs from '@/modules/FTLModule/components/FtlOrderTabs/index.vue'
import NewTable from '@/common/new-components/NewTable/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import Cheap from '@/common/components/UI/Cheap/index.vue'
import NewModal from '@/common/new-components/NewModal/index.vue'
import NewSelect from '@/ui-kit/NewSelect/index.vue'

import FtlOrderGeneral from '@/modules/FTLModule/components/FtlOrderGeneral/index.vue'
import FtlOrderPayment from '@/modules/FTLModule/components/FtlOrderPayment/index.vue'
import FtlOrderSenderAndStops from '@/modules/FTLModule/components/FtlOrderSenderAndStops/index.vue'
import FtlOrderVehicle from '@/modules/FTLModule/components/FtlOrderVehicle/index.vue'
import FtlOrderFiles from '@/modules/FTLModule/components/FtlOrderFiles/index.vue'
import FtlOrderStatuses from '@/modules/FTLModule/components/FtlOrderStatuses/index.vue'
import BidsFormFtl from '@/modules/FTLModule/components/BidsFormFtl/index.vue'

import FtlOnTheWay from '@/modules/OrdersHistoryModule/components/FtlOnTheWay/index.vue'
import FtlSetCommentModal from '@/modules/OrdersHistoryModule/components/FtlSetCommentModal/index.vue'
import FtlDeclaration from '@/modules/OrdersHistoryModule/components/FtlDeclaration/index.vue'
import FtlCrossBorder from '@/modules/OrdersHistoryModule/components/FtlCrossBorder/index.vue'
import EnterDeliveredData from '@/modules/OrdersHistoryModule/components/EnterDeliveredData/index.vue'
import EnterCompletedData from '@/modules/OrdersHistoryModule/components/EnterCompletedData/index.vue'
import UploadFtlOrderScan from '@/modules/OrdersHistoryModule/components/UploadFtlOrderScan/index.vue'
import FileReader from '@/common/components/UI/FileReader/index.vue'
import Modal from '@/common/components/UI/Modal/index.vue'
import UploadFtlStockScan from '@/modules/OrdersHistoryModule/components/UploadFtlStockScan/index.vue'

import { formatDateFromBackend } from '@/common/helpers/formatDate'

// types
import { FullFTLOrderT, StockDeliveryNoteT, FtlOrderDelayItem } from '@/core/types/orders.types'

// constants
import { FtlFileNames } from '@/core/constants/columns/FTL.columns'

// realisations
import { orders } from '@/core/realisations/orders.realisation'
import { ftl_bids } from '@/core/realisations/ftl_bids.realisation'
import { FTL } from '@/core/realisations/FTL.realisation'

// composable
import useNotifications from '@/common/composable/useNotifications'
import { useFormData } from '@/common/composable/useFormData'
import { StatusToCompletedPayload } from '@/core/types/additional_services.types'

// validation
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

import cut from '@/common/helpers/cut'
import tmsAPI from '@/new-services/tms.service'
import { TtnComment } from '@/new-services/types/tms'

const DELAY_INFO_COMMENTS_COLUMNS = [
    {
        key: 'name',
        name: 'Ответственный логист',
        withHint: true,
    },
    {
        key: 'state',
        name: 'Этап',
        withHint: true,
    },
    {
        key: 'expectedDate',
        name: 'План. дата',
        withHint: true,
    },
    {
        key: 'date',
        name: 'Факт. дата',
        withHint: true,
    },
    {
        key: 'slaComment',
        name: 'SLA',
        withHint: true,
    },
    {
        key: 'comment',
        name: 'Комментарий',
        withHint: true,
    },
]

export default defineComponent({
    components: {
        NewModal,
        BidsFormFtl,
        FtlOrderHeader,
        FtlOrderState,
        FtlOrderTabs,
        FtlOrderGeneral,
        FtlOrderPayment,
        FtlOrderSenderAndStops,
        FtlOrderVehicle,
        FtlOrderFiles,
        FtlOrderStatuses,
        //
        FtlOnTheWay,
        FtlSetCommentModal,
        FtlDeclaration,
        FtlCrossBorder,
        EnterDeliveredData,
        EnterCompletedData,
        UploadFtlOrderScan,
        FileReader,
        Modal,
        UploadFtlStockScan,
        NewTable,
        Cheap,
        TheButton,
        NewSelect,
    },
    setup() {
        const route = useRoute()
        const router = useRouter()
        const notifications = useNotifications()
        const { getFormData } = useFormData()

        const order_id = Number(route.params.order_id)

        const state = reactive({
            is_add_bid: false,
            is_loading: true,
            is_failed: false,
            is_delay_loading: false,
            //
            ftlOrder: null as FullFTLOrderT | null,
            currentTab: 'general',
            //
            ftlDelay: [] as FtlOrderDelayItem[],
            ftlDelayInbound: [] as FtlOrderDelayItem[],
            ftlDelayOutbound: [] as FtlOrderDelayItem[],
            stateId: 1,
            //
            is_status_loading: false,
            //
            is_on_the_way_loading: false,
            is_on_the_way: false,
            //
            is_set_comment_loading: false,
            is_set_comment: false,
            //
            is_export_declaration_issued: false,
            //
            is_crossing_the_border: false,
            //
            is_delivered: false,
            is_delivered_loading: false,
            //
            is_completed: false,
            is_completed_loading: false,
            //
            is_transcript_printing: false,
            is_route_printing: false,
            is_resending_to_one_c: false,
            is_invoices_printing: false,
            //
            is_scan_upload: false,
            //
            is_already_have_one_c: false,
            //
            is_printing_stock_invoice: false,
        })

        const upload_vacation_invoice = reactive({
            is_opened: false,
            is_loading: false,
            file: [] as File[],
        })

        const comment_state = reactive({
            is_open: false,
            is_loading: false,
            is_failed: false,
            list: [] as TtnComment[],
            commentId: null as number | null,
        })

        const upload_vacation_invoice_form$ = useVuelidate(
            {
                file: { required },
            },
            upload_vacation_invoice
        )

        const comment_form$ = useVuelidate(
            {
                commentId: { required },
            },
            comment_state
        )

        const upload_ftl_stock_scan = reactive({
            is_opened: false,
            ftl_stock_id: null as number | null,
            ftl_stock_directionName: null as string | null,
            ftl_stock_number: null as string | null,
        })

        const uploadStockScanHandler = (stockDeliveryNote: StockDeliveryNoteT) => {
            upload_ftl_stock_scan.ftl_stock_id = stockDeliveryNote.id
            upload_ftl_stock_scan.ftl_stock_directionName = stockDeliveryNote.directionName
            upload_ftl_stock_scan.ftl_stock_number = stockDeliveryNote.number
            upload_ftl_stock_scan.is_opened = true
        }

        const uploadStockScanCancel = () => {
            upload_ftl_stock_scan.is_opened = false
            upload_ftl_stock_scan.ftl_stock_id = null
            upload_ftl_stock_scan.ftl_stock_directionName = null
            upload_ftl_stock_scan.ftl_stock_number = null
        }

        const uploadStockScanSubmit = () => {
            uploadStockScanCancel()
            loadFtlOrder()
        }

        const loadDelay = async () => {
            try {
                state.is_delay_loading = true

                const response = await orders.getFtlOrderDelay(order_id)
                state.ftlDelay = response.data
                state.ftlDelayInbound = state.ftlDelay.filter((item) => item.stateKey === 'inbound')
                state.ftlDelayOutbound = state.ftlDelay.filter(
                    (item) => item.stateKey === 'outbound'
                )
            } catch (error) {
                console.error(error)

                notifications.notifyError({
                    error,
                    title: 'При получении комментариев FTL заказа произошла ошибка',
                })
            } finally {
                state.is_delay_loading = false
            }
        }

        const loadFtlOrder = async () => {
            try {
                state.is_loading = true

                const response = await orders.getFTLOrder(order_id)

                if (response.data.ftl_type === 2) {
                    router.replace(`/ftl/intracity/${order_id}`)
                }

                state.ftlOrder = response.data

                state.is_failed = false
            } catch (error) {
                console.error(error)

                notifications.notifyError({
                    error,
                    title: 'При получении FTL заказа произошла ошибка',
                })

                state.is_failed = true
            } finally {
                state.is_loading = false
            }
        }

        const checkAvr = async () => {
            try {
                const response = await ftl_bids.checkAvr(order_id)
                state.is_already_have_one_c = response.data.isPosted
            } catch (error) {
                console.error(error)
            }
        }

        onBeforeMount(() => {
            loadDelay()
            loadFtlOrder()
            checkAvr()
        })

        const assignStatus = async (status_code: string) => {
            if (status_code === 'canceled') {
                const answer = confirm('Вы действительно хотите отменить FTL заказ?')
                if (!answer) return
            }

            try {
                state.is_status_loading = true

                const params = {
                    id: order_id,
                    status_code,
                }

                await ftl_bids.changeStatusFTLOrder(order_id, getFormData(params))

                notifications.notify({
                    title: 'Статус изменен',
                    type: 'success',
                })

                await loadFtlOrder()
            } catch (error) {
                notifications.notifyError({
                    error,
                    title: 'При изменении статуса произошла ошибка!',
                })
            } finally {
                state.is_status_loading = false
            }
        }

        const assignStatusOnTheWayHandler = () => {
            if (state.ftlOrder) {
                if ([1].includes(state.ftlOrder.ftl_type)) {
                    state.is_on_the_way = true
                } else {
                    assignStatus('on_the_way')
                }
            }
        }

        const onSetCommentNew = (type: string) => {
            if (state.ftlDelayOutbound.length && type === 'outbound') {
                state.stateId = 1
                state.is_set_comment = true
            } else if (state.ftlDelayInbound.length && type === 'inbound') {
                state.stateId = 2
                state.is_set_comment = true
            }
        }

        const onTheWaySubmit = async (payload: FormData) => {
            try {
                state.is_on_the_way_loading = true

                await ftl_bids.changeStatusFTLOrder(order_id, payload)

                notifications.notify({
                    title: 'Статус изменен',
                    type: 'success',
                })

                state.is_on_the_way = false
                await loadFtlOrder()
            } catch (error) {
                notifications.notifyError({
                    error,
                    title: 'При изменении статуса произошла ошибка!',
                })
            } finally {
                state.is_on_the_way_loading = false
            }
        }

        const onSetCommentNewSubmit = async (delayCommentId: number) => {
            if (!delayCommentId) return

            try {
                state.is_set_comment_loading = true

                await orders.setCommentFtlOrder(order_id, delayCommentId, state.stateId)

                state.is_set_comment = false
                loadDelay()
                await loadFtlOrder()
            } catch (error) {
                notifications.notifyError({
                    error,
                    title: 'Произошла ошибка!',
                })
            } finally {
                state.is_set_comment_loading = false
            }
        }

        const onTheWayCancel = () => {
            if (state.is_on_the_way_loading) return
            state.is_on_the_way = false
        }

        const onSetCommentCancel = () => {
            if (state.is_set_comment_loading) return
            state.is_set_comment = false
        }

        const assignStatusExportDeclarationIssuedHandler = () => {
            state.is_export_declaration_issued = true
        }

        const onExportDeclarationIssuedSubmit = () => {
            state.is_export_declaration_issued = false
            loadFtlOrder()
        }

        const onExportDeclarationIssuedCancel = () => {
            state.is_export_declaration_issued = false
        }

        const assignStatusCrossingTheBorderHandler = () => {
            state.is_crossing_the_border = true
        }

        const onCrossingTheBorderSubmit = () => {
            state.is_crossing_the_border = false
            loadFtlOrder()
        }

        const onCrossingTheBorderCancel = () => {
            state.is_crossing_the_border = false
        }

        const assignStatusDeliveredHandler = () => {
            state.stateId = 2
            state.is_delivered = true
        }

        const onDeliveredSubmit = async (delivery_data: any) => {
            try {
                state.is_delivered_loading = true

                const params: any = {
                    delivery_date: delivery_data.delivery_date,
                    delivery_time: delivery_data.delivery_time,
                    received_by: delivery_data.received_by,
                    //
                    auto_count: delivery_data.auto_count,
                    auto_duration: delivery_data.auto_duration,
                    ftl_type: state.ftlOrder?.ftl_type,
                }

                if (delivery_data.additional_services) {
                    params.additional_services = [...delivery_data.additional_services]
                }
                if (delivery_data.has_downtime) {
                    params.has_downtime = delivery_data.has_downtime
                    params.downtime = delivery_data.downtime
                }
                if (delivery_data.removed_stamp && delivery_data.removed_stamp.length) {
                    params.removed_stamp = delivery_data.removed_stamp
                }
                if (delivery_data.carcass && delivery_data.carcass.length) {
                    params.carcass = delivery_data.carcass
                }
                if (delivery_data.auto_duration_client) {
                    params.auto_duration_client = delivery_data.auto_duration_client
                }

                if (delivery_data.ttn && delivery_data.ttn.length) {
                    params.ttn = delivery_data.ttn
                }

                if (delivery_data.cmr && delivery_data.cmr.length) {
                    params.cmr = delivery_data.cmr
                }

                await ftl_bids.enterDeliveryData(order_id, getFormData(params))

                notifications.notify({
                    title: 'Данные о доставке успешно внесены',
                    type: 'success',
                })

                state.is_delivered = false
                loadFtlOrder()
                loadDelay()
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При внесении данных о доставке произошла ошбика',
                })
            } finally {
                state.is_delivered_loading = false
            }
        }

        const onDelieveredCancel = () => {
            if (state.is_delivered_loading) return
            state.is_delivered = false
        }

        const getAdditionalServicesStock = computed(() => {
            if (
                state.ftlOrder &&
                state.ftlOrder.stock_delivery_notes &&
                state.ftlOrder?.stock_delivery_notes.length
            ) {
                return state.ftlOrder.stock_delivery_notes.map((delivery_note) => {
                    return {
                        additionalServices: delivery_note.additional_service,
                        directionName: delivery_note.directionName,
                    }
                })
            }

            return []
        })

        const assignStatusCompletedHandler = () => {
            state.is_completed = true
        }

        const onCompletedSubmit = async (payload?: StatusToCompletedPayload) => {
            try {
                state.is_completed_loading = true

                await ftl_bids.enterCompletedData(order_id, payload)

                state.is_completed = false

                notifications.notify({
                    title: 'Заказ завершен',
                    type: 'success',
                })

                loadFtlOrder()
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При завершении заказа произошла ошбика',
                })
            } finally {
                state.is_completed_loading = false
            }
        }

        const onCompletedCancel = () => {
            if (state.is_completed_loading) return
            state.is_completed = false
        }

        const onPrintTranscript = async () => {
            try {
                state.is_transcript_printing = true

                const response = await ftl_bids.exportExcel(order_id)

                const download_url = window.URL.createObjectURL(response)

                const link = document.createElement('a')
                link.href = download_url
                link.target = '_blank'
                link.setAttribute('download', 'Транскрипт')
                document.body.appendChild(link)
                link.click()
                link.remove()
            } catch (e) {
                console.log(e)
            } finally {
                state.is_transcript_printing = false
            }
        }

        const saveFile = (content: Blob, file_name: string) => {
            const download_url = window.URL.createObjectURL(content)

            const link = document.createElement('a')
            link.href = download_url
            link.setAttribute('download', file_name)
            document.body.appendChild(link)
            link.click()
            link.remove()
        }

        const onPrintRoute = async () => {
            try {
                state.is_route_printing = true

                const response = await FTL.printRoute(order_id)
                saveFile(response, `FTL рейс №${order_id}.pdf`)
            } catch (error) {
                console.error(error)
                notifications.notifyError({ error, title: 'При распечатке рейса произошла ошибка' })
            } finally {
                state.is_route_printing = false
            }
        }

        const onResendToOneC = async () => {
            try {
                state.is_resending_to_one_c = true

                await ftl_bids.resendOneC(order_id)

                loadFtlOrder()
                notifications.notify({
                    title: 'Заказ успешно отправлен в 1С!',
                    type: 'success',
                })
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При отправке заказа произошла ошибка',
                })
            } finally {
                state.is_resending_to_one_c = false
            }
        }

        const assignStatusCanceled = () => {
            assignStatus('canceled')
        }

        const onPrintInvoices = async () => {
            if (state.is_invoices_printing) return

            try {
                state.is_invoices_printing = true

                const response = await FTL.printFtlOrderInvoices(order_id)
                saveFile(response, `Накладные FTL заказа ${order_id}`)
            } catch (error) {
                console.error(error)

                notifications.notifyError({
                    error,
                    title: 'При распечатке накладных произошла ошибка',
                })
            } finally {
                state.is_invoices_printing = false
            }
        }

        const onDownloadScan = () => {
            const link = document.createElement('a')
            link.href = (state.ftlOrder as FullFTLOrderT).scan as string
            link.target = '_blank'
            link.setAttribute('download', `Скан FTL заказ №${order_id}`)
            document.body.appendChild(link)
            link.click()
            link.remove()
        }

        const onScanUploadHandler = () => {
            state.is_scan_upload = true
        }

        const onScanUploadSubmit = () => {
            state.is_scan_upload = false
            loadFtlOrder()
        }

        const onScanUploadCancel = () => {
            state.is_scan_upload = false
        }

        const onUploadVacationInvoiceHandler = () => {
            upload_vacation_invoice.is_opened = true
        }

        const onUploadVacationInvoiceSubmit = async () => {
            upload_vacation_invoice_form$.value.$touch()
            if (upload_vacation_invoice_form$.value.$invalid || upload_vacation_invoice.is_loading)
                return

            try {
                upload_vacation_invoice.is_loading = true

                let form_data = new FormData()
                form_data.append('order_id', order_id.toString())
                form_data.append('file', upload_vacation_invoice.file[0])

                await FTL.uploadInvoiceDocument(form_data)

                notifications.notify({ title: 'Накладная на отпуск загружена', type: 'success' })
                onUploadVacationInvoiceCancel()
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При загрузке накладной на отпуск произошла ошибка',
                })
            } finally {
                upload_vacation_invoice.is_loading = false
            }
        }

        const onUploadVacationInvoiceCancel = () => {
            upload_vacation_invoice.is_opened = false
            upload_vacation_invoice.file = []
            upload_vacation_invoice_form$.value.$reset()
        }

        const printStockInvoiceHandler = async (index: number) => {
            if (state.is_printing_stock_invoice) return

            try {
                state.is_printing_stock_invoice = true

                const response = await FTL.printFtlOrderStockDeliveryNoteInvoice(order_id, index)
                saveFile(response, `Накладная FTL заказа ${order_id} пункта ${index + 1}`)
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При распечатке накладной произошла ошибка',
                })
            } finally {
                state.is_printing_stock_invoice = false
            }
        }

        const ftlOrderFilesArray = computed(() => {
            if (!state.ftlOrder) return []

            return Object.entries(state.ftlOrder.files).map(([key, file]) => {
                return {
                    id: `file-${key}`,
                    path: file.url,
                    original_name: file.fileName,
                    title: FtlFileNames[key as keyof typeof FtlFileNames] || 'Файл без типа',
                }
            })
        })

        const senderCity = computed(() => {
            if (state.ftlOrder) {
                if (state.ftlOrder.sender) {
                    return state.ftlOrder.sender.city
                }
            }

            return null
        })

        const toggleBidCreate = () => {
            state.is_add_bid = !state.is_add_bid
        }

        const onBidCreated = () => {
            state.is_add_bid = false
            loadFtlOrder()
        }

        const isReasonOutbound = computed(() => {
            return state.ftlDelayOutbound.some((item) => !item.comment && item.isDelayed)
        })
        const isReasonInbound = computed(() => {
            return state.ftlDelayInbound.some((item) => !item.comment && item.isDelayed)
        })

        const loadComments = async () => {
            try {
                comment_state.is_loading = true

                const response = await tmsAPI.getTtnComments()

                comment_state.list = response.data.data
                comment_state.is_failed = false
            } catch (error) {
                console.error(error)
                comment_state.is_failed = true
                notifications.notifyError({
                    error,
                    title: 'При получении списка комментариев произошла ошибка',
                })
            } finally {
                comment_state.is_loading = false
            }
        }

        const toggleCancel = () => {
            comment_state.is_open = !comment_state.is_open
            if (comment_state.is_open) loadComments()
            comment_state.commentId = null
        }

        const setComment = async () => {
            comment_form$.value.$touch()
            if (comment_form$.value.$invalid || !state.ftlOrder) return

            try {
                comment_state.is_loading = true

                const payload = {
                    commentId: comment_state.commentId as number,
                }

                await tmsAPI.setComment(state.ftlOrder.id, payload)

                toggleCancel()
                loadFtlOrder()
                notifications.notify({ title: 'Комментарий добавлен', type: 'success' })
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При редактировании произошла ошибка',
                })
            } finally {
                comment_state.is_loading = false
            }
        }

        return {
            state,
            comment_state,
            upload_vacation_invoice,
            upload_vacation_invoice_form$,
            upload_ftl_stock_scan,
            comment_form$,
            loadFtlOrder,
            assignStatusOnTheWayHandler,
            onTheWaySubmit,
            onSetCommentNewSubmit,
            onTheWayCancel,
            assignStatusExportDeclarationIssuedHandler,
            onExportDeclarationIssuedSubmit,
            onExportDeclarationIssuedCancel,
            assignStatusCrossingTheBorderHandler,
            onCrossingTheBorderSubmit,
            onCrossingTheBorderCancel,
            assignStatusDeliveredHandler,
            onDeliveredSubmit,
            onDelieveredCancel,
            toggleBidCreate,
            onBidCreated,
            getAdditionalServicesStock,
            assignStatusCompletedHandler,
            onCompletedSubmit,
            onCompletedCancel,
            onPrintTranscript,
            onPrintRoute,
            onResendToOneC,
            assignStatusCanceled,
            onPrintInvoices,
            onDownloadScan,
            onScanUploadHandler,
            onScanUploadSubmit,
            onScanUploadCancel,
            onUploadVacationInvoiceHandler,
            onUploadVacationInvoiceSubmit,
            onUploadVacationInvoiceCancel,
            uploadStockScanHandler,
            uploadStockScanCancel,
            uploadStockScanSubmit,
            printStockInvoiceHandler,
            ftlOrderFilesArray,
            senderCity,
            onSetCommentCancel,
            DELAY_INFO_COMMENTS_COLUMNS,
            isReasonOutbound,
            isReasonInbound,
            cut,
            setComment,
            toggleCancel,
            onSetCommentNew,
            formatDateFromBackend,
        }
    },
})
